import { cartViewed } from '@repo/ui/src/services/analytics';
import { track } from '@repo/ui/src/services/analytics/utils';
import { basketLineInputToAnalytics } from '@repo/ui/src/services/analytics/factories';
import { Basket, ProductProps } from '@repo/ui/src/types';
import { LineItem } from '@repo/ui/src/types/lineItem';
import type { CartLineItem, CartTotals } from '@repo/ui/src/types/cart';

export const basketToCartLineItems = (basket: Basket): Array<CartLineItem> =>
  basket.lineItems.map((item) => ({
    id: item.id,
    title: item.title,
    imageUrl: item.getMainImageSize(96, 1, 1),
    imageAlt: item.title,
    price: item.price,
    originalPrice: item.hasDiscount ? item.originalPrice : undefined,
    hasDiscount: item.hasDiscount,
    quantity: item.quantity,
    isBonus: item.bonus,
    meta: { sku: item.sku },
  }));

export const basketToCartTotals = (basket: Basket): CartTotals => ({
  subtotal: basket.subtotal,
  shippingTotal: basket.shippingTotal,
  tax: basket.tax,
  total: basket.total,
  totalItems: basket.totalItems,
  currency: basket.currency,
});

/** Converts an array of out-of-stock SKUs to line item IDs for CartBody. */
export const getOutOfStockIds = (
  basket: Basket | undefined,
  outOfStockSkus: Array<string> | undefined,
): Array<string> | undefined => {
  if (!outOfStockSkus?.length || !basket) return undefined;
  return basket.lineItems.filter((li) => outOfStockSkus.includes(li.sku)).map((li) => li.id);
};

export const logCartViewed = (
  action: 'open cart' | 'close cart',
  basket: Basket,
  lineItems: Array<LineItem>,
  recommendations: Array<ProductProps>,
) => {
  track(cartViewed, {
    action,
    cart_id: basket.id,
    basket_token: basket.basketJWT,
    products: [
      ...lineItems.map((lineItem, i) => ({
        ...basketLineInputToAnalytics(lineItem),
        position: i + 1,
      })),
    ],
    rec_strand: recommendations?.map((recommendation, i) => ({
      category: recommendation.mainCategory,
      description: recommendation.description,
      image_url: recommendation.mainImageUrl,
      name: recommendation.title,
      position: i + 1,
      price: recommendation.price,
      product_id: recommendation.product_id,
      quantity: recommendation.quantity,
      sku: recommendation.sku,
      url: window.location.href,
      variant: recommendation.color,
    })),
  });
};
